module.exports = __webpack_public_path__ + "img/animals_03_H.7ddc517d.webp";